<template>
  <div class="section py-0 px-5">
      <div class="tile app-title">
        <p class="subtitle is-6">Par disponibilité</p>
      </div>
    <section>
      <b-field class="tile is-vertical">
        <div>
            <a
              class="button is-disponible"
              :class="{'is-outlined': !filtreDispoReseau.includes('is-success')}"
              @click="updateFiltre('is-success')"
              :disabled="!reseauxWithFilter.length">
              Disponible
            </a>
            <br/>
            <a
              class="button is-warning"
              :class="{'is-outlined': !filtreDispoReseau.includes('is-warning')}"
              @click="updateFiltre('is-warning')"
              :disabled="!reseauxWithFilter.length">
              Partiellement disponible
            </a>
            <br/>
            <a
              class="button is-nondisponible"
              :class="{'is-outlined': !filtreDispoReseau.includes('is-danger')}"
              @click="updateFiltre('is-danger')"
              :disabled="!reseauxWithFilter.length">
              Non disponible
            </a>
            <br/>
        </div>
      </b-field>
    </section>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteReseauxTempo-mutation-type';

const VenteReseauxTempo = createNamespacedHelpers('venteReseauxTempo');

export default {
  name: 'disponibilite',
  data() {
    return {};
  },
  computed: {
    ...VenteReseauxTempo.mapGetters({
      getFiltreDispoReseau: 'filtreDispoReseau',
      reseauxWithFilter: 'reseauxWithFilter',
    }),
    filtreDispoReseau: {
      get() {
        return this.getFiltreDispoReseau;
      },
      set(value) {
        this.setFiltreDispoReseau(value);
      },
    },
  },
  mounted() {},
  methods: {
    ...VenteReseauxTempo.mapMutations({
      setFiltreDispoReseau: types.SET_FILTRE_DISPO_RESEAU,
    }),
    ...VenteReseauxTempo.mapActions({}),
    updateFiltre(value) {
      const table = this.filtreDispoReseau;
      if (table.includes(value)) {
        const index = table.indexOf(value);
        table.splice(index, 1);
        this.filtreDispoReseau = table;
      } else {
        table.push(value);
        this.filtreDispoReseau = table;
      }
    },
  },
};
</script>

<style scoped>
  a.button{
    margin: 5px;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteReseauxTempo/filtres/disponibilite.vue